import React from "react";

const SidebarMainVector = ({color}) => {
    return (
        <svg
            width="35"
            height="13"
            viewBox="0 0 17 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.28125 1.25H15.7188M1.28125 6.5H15.7188M1.28125 11.75H15.7188"
                stroke={color}
                strokeWidth="1.3125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SidebarMainVector;
